import { isLocalhost } from "@faro-lotv/foundation";
import { IReactChildrenOnly } from "@custom-types/types";
import { LocalizeProvider } from "@faro-lotv/foreign-observers";
import { runtimeConfig } from "@src/runtime-config";
import { isNumberedDevEnvironment } from "@utils/env-utils";

/** The localization loader making it possible to implement language translation */
export function LocalizeLoader({ children }: IReactChildrenOnly): JSX.Element {
  const isNumberDevelopmentEnvironment = isNumberedDevEnvironment();

  return (
    <LocalizeProvider
      projectKey={runtimeConfig.features.localizeKey}
      initOptions={{
        // eslint-disable-next-line @typescript-eslint/naming-convention
        saveNewPhrases: !(isLocalhost() || isNumberDevelopmentEnvironment),
      }}
    >
      {children}
    </LocalizeProvider>
  );
}
